import { render, staticRenderFns } from "./menu-display.vue?vue&type=template&id=4694dc9c&scoped=true&"
import script from "./menu-display.vue?vue&type=script&lang=js&"
export * from "./menu-display.vue?vue&type=script&lang=js&"
import style0 from "./menu-display.vue?vue&type=style&index=0&id=4694dc9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4694dc9c",
  null
  
)

export default component.exports